import Radio from "./Radio";
import Group from "./Group";

const RadioObj = Object.assign(Radio, { Group });

export default RadioObj;
